<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M12 15.58q1.7 0 2.89-1.2 1.2-1.18 1.19-2.88 0-1.7-1.2-2.89A4 4 0 0 0 12 7.42q-1.7 0-2.89 1.2-1.2 1.19-1.19 2.88 0 1.7 1.2 2.89 1.18 1.2 2.88 1.19m0-1.38a2.6 2.6 0 0 1-1.91-.79 2.6 2.6 0 0 1-.79-1.91q0-1.13.79-1.91A2.6 2.6 0 0 1 12 8.8q1.13 0 1.91.79.8.78.79 1.91a2.6 2.6 0 0 1-.79 1.91 2.6 2.6 0 0 1-1.91.79m0 4.3q-3.45 0-6.28-1.9a11.2 11.2 0 0 1-4.18-5.1A11.2 11.2 0 0 1 12 4.5q3.46 0 6.28 1.9a11.2 11.2 0 0 1 4.18 5.1 11.2 11.2 0 0 1-10.46 7m0-1.5q2.82 0 5.19-1.49a10 10 0 0 0 3.61-4.01 9.77 9.77 0 0 0-17.6 0A9.8 9.8 0 0 0 12 17"
      />
    </svg>
  </span>
</template>
